import {SvgIconData} from '@shared_web/components/core/svg_icon';

export const icon_door_specifications: SvgIconData = {
  viewBox: '11 6 38 48',
  element: (
    <g>
      <path d="M48 54H12a1 1 0 0 1-1-1V7q.1-.9 1-1h27q.4 0 .7.3l9 9q.3.3.3.7v37q-.1.9-1 1m-35-2h34V16.4L38.6 8H13z" />
      <path d="M48 17h-9a1 1 0 0 1-1-1V7h2v8h8zm-31 5h26v2H17zm0 7h26v2H17zm0 7h26v2H17zm0 7h26v2H17z" />
    </g>
  ),
};
